import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { toJS } from 'mobx'
import Tooltip from '@components/Tooltip'
import classNames from 'classnames'
import moment from 'moment'
import { extendObservable, action } from 'mobx'
import { expertApi } from '@atheneum/api'
import ACL from '@components/ACL/ACL'
import Delete from '@components/Icon/Delete'
import ChevronIcon from '@components/icons/ChevronIcon'
import PinIcon from '@components/Icon/Pin'
import Button from '@components/Button'
import Loading from '@components/spinner'
import CommentAvatar from './CommentAvatar'
import PropTypes from 'prop-types'
import RichTextEditor from '@components/RichTextEditor'
import SherlockIcon from '@components/Icon/Sherlock'

import CommentStore from './Comment.store'

class Comments extends Component {
  static propTypes = {
    growlStore: PropTypes.object,
    collapsable: PropTypes.bool,
    userStore: PropTypes.object,
    commentStore: PropTypes.object,
    model: PropTypes.object,
    modelId: PropTypes.any,
    nonEditable: PropTypes.bool,
    markAllAsSeen: PropTypes.bool
  }

  constructor (props) {
    super(props)
    const keepComentsOpen = localStorage.getItem('pinComments') === 'open'

    extendObservable(this, {
      commentStore: props.commentStore || new CommentStore(),
      keepComentsOpen,
      expanded: !props.collapsable || keepComentsOpen,
      comment: '',
      loading: false
    })

    const { modelId, model, markAllAsSeen } = props
    this.commentStore.load(modelId, model, markAllAsSeen)
  }

  buildErrorGrowlProps = type => {
    return {
      title: 'Error!',
      message: `${type} is required.`,
      type: 'error',
      autoClose: true
    }
  }

  handleSubmit = action(async () => {
    if (!this.comment || this.comment === '') return null

    const { modelId, model, markAllAsSeen } = this.props
    let id = modelId
    this.loading = true

    const { expertStore } = this.props
    const { growlStore } = expertStore

    if (model === 'expert' && !Number(modelId)) {
      await expertStore.get(modelId)
      const expertProps = toJS(this.props.expertStore.expert)

      if (!expertProps.email && !expertProps.address.emails.length) {
        growlStore.addNotification(this.buildErrorGrowlProps('Email'))
        return false
      } else if (!expertProps.experiences.length) {
        growlStore.addNotification(this.buildErrorGrowlProps('Experience'))
        return false
      } else if (!expertProps.languages.length) {
        growlStore.addNotification(this.buildErrorGrowlProps('Language'))
        return false
      } else if (!expertProps.title) {
        growlStore.addNotification(this.buildErrorGrowlProps('Title'))
        return false
      } else {
        const createdExpert = await expertApi.create(expertProps)
        id = createdExpert.id
      }
    }

    this.commentStore
      .create(id, this.comment, model, markAllAsSeen)
      .catch(this.props.growlStore.showError)
      .then(() => {
        this.loading = false
        this.comment = ''

        if (model === 'expert' && !Number(modelId)) {
          this.props.history.replace(
            `${
              this.props.history.location.pathname.includes('expert-search')
                ? '/expert-search'
                : ''
            }/expert/${id}`
          )
        }
      })
  })

  handleDelete = id => {
    const { growlStore, model, modelId } = this.props
    this.commentStore.delete(id, modelId, model).catch(growlStore.showError)
  }

  renderComments = (snippet = false) => {
    const { comments } = this.commentStore
    return (snippet ? comments.slice(0, 5) : comments).map(comment => {
      const user = this.props.employeeStore.employees.filter(
        e => e.value === comment.userId
      )[0]
      const date = moment(comment.created_at).format('MMM DD YYYY, HH:mm')
      const userName = user ? user.label : 'Deleted user'
      const isEplExtractComment = comment.comment?.includes(
        'Expert included in the EPL extract'
      ) || ''

      if (user) {
        user.lastName = user.label.split(' ')[user.label.split(' ').length - 1]
        user.firstName = user.label.split(' ')[0]
      }

      return (
        <div className="comments-wrapper__comment" key={comment.id}>
          <div className="comments-wrapper__comment__image">
            <CommentAvatar user={user} />
          </div>
          <div className="comments-wrapper__comment__content">
            <div className="comments-wrapper__comment__content__info">
              {isEplExtractComment ? (
                <span className="user-full-name">EPL extract</span>
              ) : (
                <>
                  <span className="user-full-name">{userName}</span>
                  <span className="user-action">
                    {comment.user ? 'wrote' : 'created'}
                  </span>
                </>
              )}
              {!comment.breachId && (
                <ACL roles={['Admin']} inline>
                  <div onClick={() => this.handleDelete(comment.id)}>
                    <Delete />
                  </div>
                </ACL>
              )}
              {comment.breachId && (
                <>
                  <SherlockIcon
                    fill="rgb(255, 88, 88)"
                    width={16}
                    height={16}
                    style={{
                      display: 'inline-flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  />
                  <span className="user-action" style={{ marginLeft: 10 }}>
                    {' '}
                    Sherlock Breach Comment
                  </span>
                </>
              )}
              <span className="user-posted-date">{date}</span>
            </div>

            <div className="comments-wrapper__comment__content__text">
              <div dangerouslySetInnerHTML={{ __html: comment.comment }} />
            </div>
          </div>
        </div>
      )
    })
  }

  toggle = async () => {
    if (!this.expanded) {
      const { modelId, model } = this.props
      await this.commentStore.load(modelId, model, true)
    }
    this.expanded = !this.expanded
  }

  pinComments = () => {
    this.keepComentsOpen = !this.keepComentsOpen
    localStorage.setItem(
      'pinComments',
      this.keepComentsOpen ? 'open' : 'closed'
    )
  }

  render () {
    if (this.commentStore.loading) return <Loading />
    const unseenComments = this.commentStore.comments.filter(
      c => !c.seen || !c.seen.length
    )

    const { user } = this.props.userStore
    const comments = this.renderComments()

    return (
      <div
        className={classNames({
          'comments-wrapper': true,
          'comments-wrapper-no-line': this.props.collapsable
        })}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'top'
          }}>
          <div style={{ display: 'flex' }}>
            {this.props.collapsable ? (
              <>
                {comments.length ? (
                  <Tooltip
                    placement={'left'}
                    wide
                    tooltip={
                      <div className="comments-in-tooltip">
                        {this.renderComments(true)}
                      </div>
                    }>
                    <div style={{ display: 'flex' }}>
                      <h2 className="comments-wrapper__label">Comments</h2>
                      <span
                        className={classNames({
                          'comment-count': true,
                          'comment-count-orange':
                            Boolean(unseenComments && unseenComments.length) &&
                            !this.expanded
                        })}>
                        <span>{comments.length}</span>
                      </span>
                    </div>
                  </Tooltip>
                ) : (
                  <div style={{ display: 'flex' }}>
                    <h2 className="comments-wrapper__label">Comments</h2>
                    <span
                      className={classNames({
                        'comment-count': true,
                        'comment-count-orange':
                          Boolean(unseenComments && unseenComments.length) &&
                          !this.expanded
                      })}>
                      <span>{comments.length}</span>
                    </span>
                  </div>
                )}
              </>
            ) : (
              <h2 className="comments-wrapper__label">Comments</h2>
            )}
            {this.props.collapsable && (
              <span
                onClick={this.toggle}
                style={{ cursor: 'pointer', marginTop: 3, marginLeft: 5 }}>
                <ChevronIcon down={!this.expanded} up={this.expanded} />
              </span>
            )}
          </div>
          {this.expanded && (
            <PinIcon onClick={this.pinComments} active={this.keepComentsOpen} />
          )}
        </div>

        {this.expanded && (
          <div>
            <div className="comments-wrapper__comment">
              <div className="comments-wrapper__comment__image">
                <CommentAvatar user={user} />
              </div>
              {!this.props.nonEditable && (
                <div className="comments-wrapper__comment__content">
                  <div className="comments-wrapper__comment__content__info">
                    <span className="user-action">Write a comment</span>
                  </div>
                  <div className="comments-wrapper__comment__content__text">
                    <div>
                      <RichTextEditor
                        skipWrapper
                        insertLinks
                        mentions
                        value={this.comment}
                        onChange={val => (this.comment = val)}
                      />
                    </div>
                    <Button
                      secondary
                      disabled={this.loading}
                      onClick={this.handleSubmit}>
                      Submit
                    </Button>
                    {this.loading && <Loading inline />}
                  </div>
                </div>
              )}
            </div>
            {comments}
          </div>
        )}
      </div>
    )
  }
}

export default inject(
  'userStore',
  'growlStore',
  'employeeStore',
  'expertStore'
)(observer(Comments))

Comments.propTypes = {
  modelId: PropTypes.number.isRequired,
  model: PropTypes.string.isRequired,
  userStore: PropTypes.object,
  growlStore: PropTypes.object
}
